import { render } from "./App.vue?vue&type=template&id=17cb1c64"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17cb1c64&lang=css"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__